"use strict";
const angular = require("angular");

export class AddExposureController {
  title = "ADD SEASON EXPOSURE";
  buttonLabel = "Create";
  seasons = [];
  currentSeason;
  exposure = {};

  /*@ngInject*/
  constructor(appConfig, $uibModalInstance, $state, exposure, ngToast) {
    "ngInject";

    this.currentSeason = this.getCurrentSeason();

    if (exposure) {
      this.exposure = exposure;
      this.title = "EDIT SEASON EXPOSURE";
      this.buttonLabel = "Update";
    } else {
      this.exposure.season = this.currentSeason;
    }

    this.incidentType = appConfig.incidentType;
    this.severities = appConfig.severities;
    this.message = "Hello";
    this.modal = $uibModalInstance;
    this.$state = $state;
    this.ngToast = ngToast;

    let now = this.getCurrentSeason();
    console.log(now);
    for (let year = now; year >= 1960; year--) {
      this.seasons.push(year);
    }
  }

  getCurrentSeason() {
    const now = new Date();
    let year = now.getFullYear();
    const month = now.getMonth() + 1;
    console.log("month:", month);
    console.log(year, month);

    if (month > 9) year++;

    return year;
  }

  create() {
    if (!this.exposure.season) {
      this.error = "Season must be provided";
    } else {
      this.modal.close(this.exposure);
    }
  }

  cancel() {
    this.modal.close();
  }
}

export default angular
  .module("hccApp.addExposure", [])
  .controller("AddExposureController", AddExposureController).name;



// WEBPACK FOOTER //
// ./client/app/exposure/addExposure.controller.js